<template>
  <div class="page_user_message">
    <div class="head">
      <div class="head-background">
        <img :src="backgroundImg" alt="" style="width: 100%; height: 100%" />
      </div>
      <a-row class="row_margin">
        <a-col :span="18" class="head_title_text">
          {{ companyInfo.departName }}
        </a-col>
      </a-row>
      <a-row class="row_margin" v-if="companyInfo.description">
        <a-col :span="20" class="head_info_text">
          {{ companyInfo.description }}
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="2" class="head_info"> 权限到期： </a-col>
        <a-col :span="4" class="head_info_text">
          {{ companyInfo.accountExpirationTime }}
        </a-col>
        <a-col :span="2" class="head_info_text">
          <a href="#" style="text-decoration: underline">续费</a>
        </a-col>
        <a-col :span="2" class="head_info"> 项目上限： </a-col>
        <a-col :span="2" class="head_info_text">
          {{ companyInfo.projectNum ? companyInfo.projectNum : 0 }}/{{
            companyInfo.accountProjectLimit
          }}
        </a-col>
        <a-col :span="2" class="head_info"> 人员上限： </a-col>
        <a-col :span="2" class="head_info_text">
          {{ companyInfo.memberNum }}/{{ companyInfo.accountMemberLimit }}
        </a-col>
        <a-col :span="2" class="head_info"> 团队上限： </a-col>
        <a-col :span="2" class="head_info_text">
          {{ companyInfo.teamNum }}/{{ companyInfo.accountTeamLimit }}
        </a-col>
      </a-row>
    </div>
    <div class="content">
      <a-tabs :value="activeTab" @change="changeTab">
        <a-tab-pane key="1" tab="成员管理">
          <Member :memberList="memberList" @onSearch="onSearch" @handleChange="handleOrderChange" @del="handelDel" />
        </a-tab-pane>
        <a-tab-pane key="2" tab="团队管理">
          <Department
            :cards="teamList"
            :editStatus="editTeamStatus"
            @selectRadio="selectRadio($event)"
            :list_params="list_params"
            :total="teamTotal"
            @pageChange="pageChange"
            @toDetail="toTeamDetail"
          />
        </a-tab-pane>
        <a-button
          type="primary"
          v-if="activeTab == 1"
          class="tabs_button"
          slot="tabBarExtraContent"
          @click="showAddModal"
        >
          添加成员
        </a-button>
        <!-- 团队管理 -->
        <a-button
          type="primary"
          v-if="activeTab == 2 && editTeamStatus == false"
          class="tabs_button button_margin"
          slot="tabBarExtraContent"
          @click="editTeam()"
          >编辑团队
        </a-button>
        <a-button
          type="primary"
          v-if="activeTab == 2 && editTeamStatus == false"
          class="tabs_button"
          slot="tabBarExtraContent"
          @click="createTeam"
        >
          创建团队
        </a-button>
        <!-- 编辑团队状态 -->
        <a-button
          type="primary"
          v-if="activeTab == 2 && editTeamStatus == true"
          class="tabs_button button_margin"
          slot="tabBarExtraContent"
          >删除
        </a-button>
        <a-button
          type="primary"
          v-if="activeTab == 2 && editTeamStatus == true"
          class="tabs_button"
          slot="tabBarExtraContent"
          @click="editTeam()"
        >
          取消
        </a-button>
      </a-tabs>
    </div>

    <AddMember :visible="visible" @handleOk="handleOk" :depId="depId" />
    <a-modal
      v-model="teamVisible"
      title="创建团队"
      @ok="handleTeamCreate"
      okText="添加"
      cancelText="取消"
    >
      <div class="member-head-content">
        <a-row style="display: flex; align-items: center">
          <a-col :offset="1" :span="6" class="member-input">团队名称：</a-col>
          <a-col :span="14" class="member-input">
            <a-input v-model="teamParams.departName" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 36px; display: flex; align-items: center">
          <a-col :offset="1" :span="6" class="member-input">机构编码：</a-col>
          <a-col :span="14" class="member-input">
            <a-input v-model="teamParams.orgCode" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 36px; display: flex; align-items: center">
          <a-col :offset="1" :span="6" class="member-input">团队描述：</a-col>
          <a-col :span="14" class="member-input">
            <a-input type="textarea" v-model="teamParams.description" />
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
import HmSearchCard from "@/components/HmSearchCard";
import Member from "@/components/Member";
import AddMember from "@/components/AddMember";
import global_ from "@/utils/global.js";
import Department from "@/components/Department";
import companyApi from "@/request/api-manager/company.js";
import departUserApi from "@/request/api-manager/departUser.js";
export default {
  data() {
    return {
      backgroundImg: require("@/assets/user-message/company.png"),
      activeTab: 1,
      editTeamStatus: false,
      teamList: [],
      selectTeamIds: [],
      visible: false,
      list_total: 100,
      teamTotal: 0,
      list_params: {
        pageSize: 10,
        pageNo: 1,
      },
      companyInfo: {},
      memberList: [],

      teamVisible: false,
      teamParams: {
        departName: "",
        description: "",
        orgCode: ""
      },
      depId: ''
    };
  },
  components: {
    HmSearchCard,
    Member,
    Department,
    AddMember,
  },
  mounted() {
    this.cards = global_.teamList.map((element) => {
      element.showSelect = false;
      return element;
    });
    this.getCompanyInfo();
    this.getCompanyMember();
    this.getCompanyTeam();
    this.depId = this.$route.query.companyId
  },
  methods: {
    toDetail(projectId) {
      this.$router.push({
        path: "/component/list",
        query: { projectId: projectId },
      });
    },
    changeTab(key) {
      this.activeTab = key;
      this.visible = false
    },
    editTeam() {
      this.editTeamStatus = !this.editTeamStatus;
    },
    selectRadio(data) {
      if (!data.showSelect) {
        this.selectTeamIds.push(data.id);
      } else {
        this.selectTeamIds = this.selectTeamIds.filter((id) => {
          return id != data.id;
        });
      }
      data.showSelect = !data.showSelect;
    },
    handleOk(params) {
      if (this.checkUniqueMember(params.userId)) {
        this.$message.warning("成员已存在")
        return
      }
      companyApi.addMemeber(params).then(() => {
        this.$message.success('添加成功')
        this.visible = false;
        this.getCompanyMember()
      })
    },
    checkUniqueMember(id) {
      let uniqueStatus = false
      this.memberList.forEach(item => {
        if ( item.userId == id ) {
          uniqueStatus = true
        }
      })
      return uniqueStatus
    },
    showAddModal() {
      this.visible = true;
    },
    pageChange(page) {
      let self = this;
      self.list_params.pageNo = page;
    },
    getCompanyInfo() {
      let self = this;
      let id = self.$route.query.companyId;
      companyApi.getCompanyById({ id }).then((res) => {
        self.companyInfo = res.result;
      });
    },
    getCompanyMember(name = '', order = 'asc') {
      let self = this;
      let id = self.$route.query.companyId;
      departUserApi.list({ depId: id, userRealname: `*${name}*`, order, column: 'userUsername' }).then((res) => {
        res.result.records.forEach((resp) => {
          resp.roleType = this.correspondingRelation(
            resp.roleType,
            global_.roleType
          );
        });
        self.memberList = res.result.records;
      });
    },
    handleOrderChange(val) {
      this.getCompanyMember('',val)
    },
    onSearch(val) {
      this.getCompanyMember(val)
    },
    handelDel(id) {
      companyApi.delMemeber({ id }).then(res => {
        this.$message.success('删除成功')
        this.getTeamMember()
      })
    },
    getCompanyTeam() {
      let self = this;
      let id = self.$route.query.companyId;
      companyApi.listTeam({ companyId: id }).then((res) => {
        self.teamList = res.result.records;
      });
    },

    toTeamDetail(teamId) {
      this.$router.push({
        path: "/team-page/index",
        query: { teamId: teamId },
      });
    },
    createTeam() {
      console.log(this.companyInfo);
      this.teamVisible = true;
    },
    handleTeamCreate() {
      let {
        accountId,
        id
      } = this.companyInfo
      let params = {
        ...this.teamParams,
        accountId,
        parentId: id,
        orgType: "2",
        status: "1"
      }
      companyApi.createTeam(params).then(() => {
        this.$message.success('创建团队成功!')
      })
    }
  },
};
</script>
<style scoped>
@import "./index.css";
</style>